/**
 * L'EXPORT DE RÉFÉRENCE D'UN REGISTRE — point d'entrée GED.
 *
 * Créé en L-1 (06/10/2026), MONTÉ AU SOCLE PARTAGÉ en L0 (10/10/2026) :
 * l'implémentation vit dans `shared/ui/exportRegistre.ts` (recopiée ici sous
 * `src/shared/`), parce que `<Tableau>` — lui aussi partagé — l'intègre. Ce
 * fichier ne fait que réexporter, pour que `NC.tsx`, `CataloguePlat.tsx` et le
 * test `front-export-registre` gardent leur chemin d'import.
 *
 * Règles (PROMPT-TABLEAUX §1) : colonnes déclarées par le code, lignes
 * FILTRÉES, en-tête daté et signé, `;` + BOM UTF-8, anti-formule `= + - @`.
 */
export {
  celluleCsv, nomFichierExport, enteteExport, construireExport, telechargerExport, dateHeureExport,
} from '../shared/exportRegistre';
export type { ColonneExport, DemandeExport } from '../shared/exportRegistre';
